<mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;height:350px;min-height: 350px;">
    <mat-card-header>
       
    </mat-card-header>    
    <mat-card-content>
        <div class="row">
            <div class="col-2 ace-heading-text-secondary">
                <span class="ace-heading-text-secondary">Invoice Aging Comments</span>
            </div>
            
            <div class="col-3 ace-heading-text-secondary">
                <span class="ace-heading-text-secondary">
                    @if(displayDateString == ''){
                        Date Last Updated: N/A
                    }
                    @else
                    {
                        Date Last Updated: {{displayDateString}}
                    }
                </span>
            </div>

            <div class="col-3 ace-heading-text-secondary">
                <span class="ace-heading-text-secondary">
                    @if(displayLastUpdatedUserName == ''){
                        Last Updated By: N/A
                    }
                    @else
                    {
                        Last Updated By: {{displayLastUpdatedUserName}}
                    }
                </span>
            </div>
            
        </div>

        <form [formGroup]="commentsForm"
        (submit)="onUpdateAgingComments()">
        
        <div class="row" style="overflow-x:auto;overflow-y:auto;margin-top:10px;">
            <div class="col-12">
                <mat-form-field appearance="fill" style="width:100%">
                    <mat-label>Comments</mat-label>
                    <textarea matInput placeholder="Comments" formControlName="comments"  maxlength="2000" rows="5"></textarea>
                </mat-form-field>
            </div>
            <div class="col-12">
                <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;">Update</button>
                <button type="button" class="btn btn-primary mt-3 ace-blue" style="margin-left:10px;" (click)="onClearExistingComments()" matTooltip="Removes all comments from this invoice">Clear Comments</button>
            </div>
        </div>
        </form>
    </mat-card-content>
</mat-card>
